import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import docTypes from "./tag-types";
export var erpResourceApi = createApi({
    reducerPath: 'resourceApi',
    baseQuery: fetchBaseQuery({
        baseUrl: (window === null || window === void 0 ? void 0 : window.baseUrl) + "api/resource/",
        credentials: 'include'
    }),
    tagTypes: docTypes,
    endpoints: function (build) { return ({
        list: build.query({
            query: function (_a) {
                var method = _a.method, _b = _a.fetchCount, fetchCount = _b === void 0 ? 1000000 : _b, _c = _a.fields, fields = _c === void 0 ? [] : _c, _d = _a.filters, filters = _d === void 0 ? [] : _d, searchParams = _a.searchParams;
                return "".concat(method, "?fields=").concat(JSON.stringify(fields), "&filters=").concat(filters.length > 0 ? filters : JSON.stringify([]), "&limit_page_length=").concat(fetchCount, "&").concat(searchParams);
            },
            providesTags: ['list']
        }),
        get: build.query({
            query: function (_a) {
                var doc = _a.doc, name = _a.name;
                return "".concat(doc, "/").concat(name);
            },
            providesTags: function (result, error, arg) {
                if (result) {
                    return [{ type: 'doc', id: "".concat(result.data.doctype, "-").concat(result.data.name) }];
                }
                return ['doc'];
            }
        }),
        create: build.mutation({
            query: function (_a) {
                var doc = _a.doc, payload = _a.payload;
                return ({
                    url: "".concat(doc),
                    method: 'POST',
                    body: payload,
                });
            },
            invalidatesTags: ['list', 'doc']
        }),
        update: build.mutation({
            query: function (_a) {
                var doc = _a.doc, name = _a.name, payload = _a.payload;
                return ({
                    url: "".concat(doc, "/").concat(name),
                    method: 'PUT',
                    body: payload,
                });
            },
            invalidatesTags: ['doc', 'list']
        }),
        delete: build.mutation({
            query: function (_a) {
                var doc = _a.doc, name = _a.name;
                return ({
                    url: "".concat(doc, "/").concat(name),
                    method: 'DELETE'
                });
            },
            invalidatesTags: ['list', 'doc']
        }),
    }); }
});
export var useListQuery = erpResourceApi.useListQuery, useGetQuery = erpResourceApi.useGetQuery, useUpdateMutation = erpResourceApi.useUpdateMutation, useCreateMutation = erpResourceApi.useCreateMutation, useDeleteMutation = erpResourceApi.useDeleteMutation;
export default erpResourceApi;
